<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <h1 class="headline mb-4">
            {{ $t('workersList.history') }}
          </h1>
        </v-flex>
      </v-layout>

      <v-flex d-flex xs12 mt-4 mr-4>
        <div class="search">
          <v-text-field
            v-model="searchString"
            type="text"
            solo
            :placeholder="$t('common.fields.fullNamePlaceholder')"
          />

          <v-btn
            type="button"
            class="warning mb-4"
            depressed
            large
            @click="filters.search = searchString"
          >
            {{ $t('common.btns.search') }}
          </v-btn>
        </div>

        <v-menu
          ref="menuDate"
          :close-on-content-click="false"
          v-model="menuDate"
          :return-value.sync="filters.dates"
          max-width="280px"
          min-width="280px"
          class="pr-4 mt-2"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-on="on"
              v-model="filters.dates"
              prepend-icon="mdi-calendar"
              :label="$t('common.fields.rentDate')"
              readonly
              class="date"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="filters.dates"
            color="primary lighten-1"
            width="280"
            range
            :locale="$i18n.locale"
            :selected-items-text="filters.dates.toString()"
            :allowed-dates="allowedDates"
            @input="changeDate"
          ></v-date-picker>
        </v-menu>
      </v-flex>
    </v-flex>

    <v-flex xs12>
      <v-data-table
        :headers="headers"
        :items-per-page="perPage"
        :items="list"
        :loading="loading"
        hide-default-footer
      >
        <template #[`item.result`]="{ item }">
          {{ item.result || '—' }}
        </template>

        <template #footer>
          <v-divider />
          <div class="pt-1 pb-2">
            <v-pagination
              color="warning"
              :value="currentPage"
              :length="lastPage"
              dark
              circle
              @input="fetchHistory({ ...filters, page: $event })"
            />
          </div>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex';
import checkRouteAccess from '@/helpers/checkRouteAccess';

export default {
  beforeRouteEnter(to, from, next) {
    checkRouteAccess('finance_expanse_history_view', next);
  },
  data: () => ({
    loading: false,
    menuDate: false,
    searchString: '',

    filters: {
      search: '',
      dates: [],
    },
  }),
  watch: {
    filters: {
      deep: true,
      handler(params) {
        this.fetchHistory(params);
      },
    },
  },
  computed: {
    ...mapState({
      list: (state) => state['company-expenses'].history.list,
      currentPage: (state) => state['company-expenses'].history.currentPage,
      lastPage: (state) => state['company-expenses'].history.lastPage,
      perPage: (state) => state['company-expenses'].history.perPage,
    }),
    headers() {
      return [
        {
          text: this.$t('common.number'),
          value: 'num',
          sortable: false,
        },
        {
          text: this.$t('common.table.employee'),
          value: 'name',
          sortable: false,
        },
        {
          text: this.$t('common.fields.email'),
          value: 'email',
          sortable: false,
        },
        {
          text: this.$t('workersList.history.updatedDate'),
          value: 'createdAt',
          sortable: false,
        },
        {
          text: this.$t('workersList.history.action'),
          value: 'key',
          sortable: false,
        },
        {
          text: this.$t('driverHistory.tableHeaders.details'),
          value: 'result',
          sortable: false,
        },
        {
          text: this.$t('workersList.history.createdDate'),
          value: 'record_date',
          sortable: false,
        },
      ];
    },
  },
  methods: {
    fillDates() {
      const { dates } = this.$route.query;

      if (dates) this.filters.dates = dates;
      else this.filters.dates = [this.today, this.today];
    },
    changeDate(val) {
      if (val.length === 2) {
        this.$refs.menuDate.save(this.filters.dates);
      }
    },
    allowedDates(value) {
      const [from, to] = this.filters.dates;

      if (!from) return true;
      if (to) return true;

      const firstDate = new Date(from);
      const nextDate = new Date(value);

      return nextDate >= firstDate;
    },
    async fetchHistory(params) {
      this.loading = true;
      await this.$store.dispatch('company-expenses/fetchHistory', params);
      this.loading = false;
    },
  },
  created() {
    this.fillDates();
  },
};
</script>

<style lang="scss">
.search {
  display: flex;
  max-width: 450px;
  width: 100%;

  &-field {
    width: 100%;
  }
}

.date {
  max-width: 250px;
  margin-left: 20px;
}
.v-pagination button {
  box-shadow: none !important;
}
</style>
